import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import { FontAwesomeIcon } from '@vr/lib';
import { useSelector } from 'react-redux';
import { Logo as DefaultLogo } from '../../elements';
import BreadcrumbsComponent from '~/components/Breadcrumbs';
import devices from '~/styles/devices';
import { BreadcrumbsContext } from '~/providers/BreadcrumbsProvider';

const Logo = styled(DefaultLogo)`
  margin-right: 33px;
`;
const Breadcrumbs = styled(BreadcrumbsComponent)`
  display: none;
  @media (min-width: ${devices.mobile}) {
    display: block;
  }
`;
const ButtonMenu = styled.button`
  color: ${({ theme }) => theme.colors.white};
  border: 2px solid ${({ theme }) => theme.colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  width: 86px;
  height: 24px;
  background-color: transparent;
  font-weight: 700;
  cursor: pointer;
`;
const CloseIcon = styled(FontAwesomeIcon)`
  font-size: 0.9375rem;
  margin-right: 9px;
  color: ${({ theme }) => theme.colors.white};
`;
const ButtonText = styled.span`
  text-transform: uppercase;
  font-size: 0.75rem;
`;

const Header = ({ onClick }) => {
  const logo = useSelector(state => state?.issuer?.logo);
  const breadcrumbs = useContext(BreadcrumbsContext);
  const { values } = breadcrumbs;

  return (
    <header>
      <Grid container spacing={2} alignItems="center" justify="space-between">
        <Grid style={{ display: 'flex' }} alignItems="center" item>
          <Logo alt={logo?.alt} src={logo?.src} />
          {values?.label && <Breadcrumbs values={values} />}
        </Grid>
        <Grid item>
          <ButtonMenu aria-label="Fechar" onClick={() => onClick()}>
            <CloseIcon icon={['fas', 'times']} />
            <ButtonText>fechar</ButtonText>
          </ButtonMenu>
        </Grid>
      </Grid>
    </header>
  );
};

Header.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default Header;
